import { render } from "./SaleChannelIndex.vue?vue&type=template&id=5488b7e2&scoped=true"
import script from "./SaleChannelIndex.vue?vue&type=script&lang=js"
export * from "./SaleChannelIndex.vue?vue&type=script&lang=js"

import "./SaleChannelIndex.vue?vue&type=style&index=0&id=5488b7e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5488b7e2"]])

export default __exports__